import React, {useState} from "react";
import { FormattedMessage } from "react-intl";

// @mui/material components
import { Dialog, DialogActions, DialogTitle, DialogContent, DialogContentText } from "@mui/material";

// core components
import Button from "components/button/button";
import Loader from '../../configuration/components/loader';

// actions
import {deleteCorner} from "../../../api/corner/delete";
import {getTranslation} from "../../../domain/helpers/translations";

function DeleteDialog(props) {
    const { corner, closeDialog, isOpen, deleted } = props;

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const removeCorner = () => {
        if (!corner) {
            return;
        }
        setLoading(true);
        setError(null);
        deleteCorner(corner.id)
            .then(() => {
                deleted();
                closeDialog(true);
            })
            .catch((e) => {
                setError(e.message);
                setLoading(false);
            });
    };

    return (
        <Dialog
            open={isOpen}
            onClose={closeDialog}
            maxWidth={'xs'}
            scroll={'body'}
        >
            <DialogTitle>
                <FormattedMessage
                    id={"corner.delete.title"}
                    values={{ corner: getTranslation(corner).name }}
                />
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <FormattedMessage id={"corner.delete.text"} />
                </DialogContentText>
                {error && (
                    <DialogContentText style={{color: 'red', marginTop: '10px'}}>
                        {error}
                    </DialogContentText>
                )}
            </DialogContent>
                <DialogActions>
                    <Button color={"info"} simple onClick={closeDialog} disabled={loading}>
                        <FormattedMessage id={"corner.delete.cancel"} />
                    </Button>
                    <Button
                        round
                        color={"danger"}
                        type="submit"
                        disabled={loading}
                        onClick={() => removeCorner(corner)}
                    >
                        <FormattedMessage id={"corner.delete.submit"} />
                        {loading && <Loader />}
                    </Button>
                </DialogActions>
        </Dialog>
    )
}

export default DeleteDialog;
